import { ME_CACHE_KEY, ME_CACHE_TTL_MS } from '_constants/me-cache.constants'

const FIREBASE_AUTH_USER_KEY_PREFIX = 'firebase:authUser:'
const LOGIN_PATH_SEGMENT = '/login'

const hasFreshMeCache = (): boolean => {
  const cached = window.localStorage.getItem(ME_CACHE_KEY)
  if (!cached) {
    return false
  }
  const { cachedAt } = JSON.parse(cached) as { cachedAt?: number }
  return typeof cachedAt === 'number' && Date.now() - cachedAt < ME_CACHE_TTL_MS
}

// Firebase rewrites its stored user while it initialises, so the app's own cached user (cleared
// on logout) is what reliably marks a returning signed-in user during the first frames.
export const hasStoredCoreSession = (): boolean => {
  try {
    if (window.location.pathname.includes(LOGIN_PATH_SEGMENT)) {
      return false
    }
    return (
      hasFreshMeCache() ||
      Object.keys(window.localStorage).some((key) => key.startsWith(FIREBASE_AUTH_USER_KEY_PREFIX))
    )
  } catch {
    return false
  }
}
